import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Gadgets
import TableGadget from '../gadgets/tableGadget';
import SummaryGadget from '../gadgets/summaryGadget';
import PieGadget from '../gadgets/pieGadget';

// Components
import GridLayout from "react-grid-layout";

//Styles
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./index.scss";


//dashboard Id 1501
//dashboardUserGadgets  dasboardId 1501 [] gadgetId 123,124
//riskEventTable_123
import { getDashboard } from './redux/slice';

export const DasboardView = ({ configHandler, location, getCurrentFilters, hasFilters, renderColumnByType, onClick, savePreferences, defaultSorts = [], onHierarchyChange }) => {


    /*  filters = { filters }
     getCurrentFilters = { getCurrentFilters }
     hasFilters = { hasFilters } */

    // const layout = [
    //     { w: 2, h: 2, x: 0, y: 1, i: "0" },
    //     { w: 2, h: 2, x: 2, y: 1, i: "1" },
    //     { w: 4, h: 1, x: 0, y: 0, i: "2" },
    //     { w: 4, h: 1, x: 0, y: 3, i: "3" },
    //     { w: 4, h: 2, x: 0, y: 4, i: "4" }, // component that spans across 3 columns
    // ];
    const dispatch = useDispatch();
    const { loading, dashboard } = useSelector(state => state.dashboardRedux);

    const cols = 4; // Fixed at 4 columns
    const gridRef = useRef(null);
    const [gridWidth, setGridWidth] = useState(window.innerWidth - 320);
    const [gadgetDimensions, setGadgetDimensions] = useState({});

    // Function to calculate the dimensions of each gadget
    const calculateGadgetDimensions = useCallback((layout) => {
        const dimensions = {};
        layout?.forEach((item) => {
            const containerWidth = (gridWidth / cols) * item.w - 20; // 20px for margin
            const containerHeight = (260 * item.h) - 20; // rowHeight * h - margin
            dimensions[item.i] = {
                width: containerWidth,
                height: containerHeight
            };
        });
        setGadgetDimensions(dimensions);
    }, [gridWidth, cols]);

    // Resize handler to update grid width
    useEffect(() => {
        const handleResize = () => {
            const newWidth = window.innerWidth - 320;
            setGridWidth(newWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        dispatch(getDashboard({ location }));
    }, [location]);

    // Memoize layoutGadgets to avoid unnecessary re-renders
    const layoutGadgets = useMemo(() => {
        return dashboard?.gadgets?.map((gadget) => {
            let layout = { ...gadget.layout, i: gadget.id.toString() };
            return layout;
        });
    }, [dashboard?.gadgets]);

    // Calculate dimensions when layout or grid width changes
    useEffect(() => {
        if (layoutGadgets && layoutGadgets.length > 0) {
            calculateGadgetDimensions(layoutGadgets);
        }
    }, [layoutGadgets, calculateGadgetDimensions]);

    // Handler for when the layout changes (resize or drag)
    const handleLayoutChange = useCallback((newLayout) => {
        calculateGadgetDimensions(newLayout);
    }, [calculateGadgetDimensions]);

    return (
        <div style={{ width: "100%" }}>
            {/* {loading && <Loading full />} */}
            <div style={{ width: "100%" }}>
                <GridLayout
                    ref={gridRef}
                    className="layout"
                    layout={layoutGadgets}
                    cols={cols}
                    rowHeight={260}
                    width={gridWidth}
                    isResizable={dashboard.isStatic ? false : true}
                    isDraggable={dashboard.isStatic ? false : true}
                    compactType={'vertical'} // Always compact vertically to close gaps
                    preventCollision={false} // Allows overlap when not static
                    verticalCompact={true} // Force vertical compaction
                    onLayoutChange={handleLayoutChange}
                    draggableCancel="button, input, textarea, select, .no-drag, span"
                    onResize={(layout, oldItem, newItem) => {
                        // Update dimensions in real-time during resize
                        const dimensions = { ...gadgetDimensions };
                        const containerWidth = (gridWidth / cols) * newItem.w - 20;
                        const containerHeight = (260 * newItem.h) - 20;
                        dimensions[newItem.i] = {
                            width: containerWidth,
                            height: containerHeight
                        };
                        setGadgetDimensions(dimensions);
                    }}
                >
                    {
                        dashboard?.gadgets?.map((gadget) => {
                            const mergedFilters = getCurrentFilters ? getCurrentFilters(gadget.gadgetKey, gadget.settings) : {}
                            const customFilters = hasFilters ? hasFilters(gadget.gadgetKey) : false
                            const gadgetId = gadget.id.toString();
                            const dimensions = gadgetDimensions[gadgetId] || { width: 0, height: 0 };
                            let currentConfig = { ...gadget.settings };
                            let sort = defaultSorts?.length ? defaultSorts.find(sort => sort?.key === gadget?.gadgetKey) : null
                            if (sort?.value) {
                                currentConfig = {
                                    ...currentConfig,
                                    defaultSort: sort.value
                                }
                            }
                            // Default sort for Risk Events gadgets: avgEvents DESC
                            if (!sort?.value && (gadget.gadgetKey === 'RiskEventsByDriver' || gadget.gadgetKey === 'RiskEventsByTag')) {
                                currentConfig = {
                                    ...currentConfig,
                                    defaultSort: { key: 'avgEvents', order: 'desc' }
                                }
                            }
                            switch (gadget.gadgetType) {
                                case 'tableGadget':
                                    return (
                                        <div key={gadgetId} style={{ height: '100%' }}>
                                            <TableGadget
                                                gadgetkey={gadget.gadgetKey}
                                                name={gadget.name}
                                                gadgetId={gadget.gadgetId}
                                                filters={mergedFilters}
                                                config={currentConfig}
                                                configHandler={configHandler}
                                                customFilters={customFilters}
                                                renderColumnByType={renderColumnByType}
                                                isStatic={dashboard.isStatic}
                                                containerDimensions={dimensions}
                                                savePreferences={savePreferences}
                                                onHierarchyChange={onHierarchyChange}
                                            />
                                        </div>
                                    );
                                case 'summaryGadget':
                                    return (
                                        <div key={gadgetId} style={{
                                            height: '100%',
                                            width: '100%',
                                            overflow: 'visible'
                                        }}>
                                            <SummaryGadget
                                                gadgetkey={gadget.gadgetKey}
                                                name={gadget.name}
                                                gadgetId={gadget.gadgetId}
                                                filters={mergedFilters}
                                                config={gadget.settings}
                                                configHandler={configHandler}
                                                customFilters={customFilters}
                                                containerDimensions={dimensions}
                                                onClick={onClick}
                                            />
                                        </div>

                                    )
                                case 'pieGadget':
                                    return (
                                        <div key={gadgetId} style={{ height: '100%' }}>
                                            <PieGadget
                                                gadgetkey={gadget.gadgetKey}
                                                name={gadget.name}
                                                gadgetId={gadget.gadgetId}
                                                filters={mergedFilters}
                                                config={gadget.settings}
                                                configHandler={configHandler}
                                                customFilters={customFilters}
                                                containerDimensions={dimensions}
                                            />
                                        </div>
                                    )
                                default:
                                    return <div key={gadgetId} style={{ background: "#d0f0c0", height: '100%' }}>Componente {gadget.gadgetKey}</div>;
                            }
                        })}
                </GridLayout>
            </div>
        </div>
    );
}

export default DasboardView;